import "./style.css";
/**
 * Scratchcard e Calendar Slider Integrados
 * Script que combina as funcionalidades do Scratchcard e do Calendar Slider
 */
const calendar = document.querySelector(".scratch");
if (calendar) {
    document.addEventListener("DOMContentLoaded", function () {
        // Verifica a largura da tela e recarrega a página se necessário
        checkScreenWidth();
        // Inicializa o Scratchcard
        initScratchcard();
        // Inicializa o Calendar Slider
        initCalendarSlider();
        /**
         * Verifica a largura da tela e ajusta o layout conforme necessário
         * quando o usuário redimensiona a janela cruzando o limite de 768px
         */
        function checkScreenWidth() {
            let isMobile = window.innerWidth <= 768;
            const calendarNavigation = document.querySelector(".calendar-navigation");
            const calendarPagination = document.querySelector(".calendar-pagination");
            window.addEventListener("resize", function () {
                // Se cruzar o limite de 768px (mudar de desktop para mobile ou vice-versa)
                if ((window.innerWidth <= 768 && !isMobile) ||
                    (window.innerWidth > 768 && isMobile)) {
                    // Atualiza o estado
                    isMobile = window.innerWidth <= 768;
                    // Ajusta o layout sem recarregar a página
                    if (isMobile) {
                        calendarNavigation.style.display = "none";
                        calendarPagination.style.display = "flex";
                    }
                    else {
                        calendarNavigation.style.display = "block";
                        calendarPagination.style.display = "none";
                    }
                }
            });
        }
        /**
         * Inicializa o componente Scratchcard
         */
        function initScratchcard() {
            const scratchcardElement = document.querySelector(".scratchcard");
            if (scratchcardElement) {
                new Scratchcard(scratchcardElement);
            }
        }
        /**
         * Inicializa o componente Calendar Slider
         */
        function initCalendarSlider() {
            // Elementos do slider
            const slider = document.querySelector(".calendar-slider");
            const cards = document.querySelectorAll(".raffle-card");
            const prevButton = document.querySelector(".nav-button-item.prev");
            const nextButton = document.querySelector(".nav-button-item.next");
            const paginationContainer = document.querySelector(".calendar-pagination");
            let paginationDots = document.querySelectorAll(".pagination-dot");
            if (!slider || !cards.length)
                return;
            // Verifica se está em modo mobile
            const isMobile = window.innerWidth <= 768;
            // Configurações do slider
            let currentPosition = 0;
            const totalCards = cards.length;
            const cardWidth = cards[0].offsetWidth;
            const cardMargin = 32; // Margem entre os cards (gap)
            const cardStep = cardWidth + cardMargin; // Largura total de um card com margem
            // Se estiver no mobile, ajusta o estilo do slider para mostrar todos os cards
            if (isMobile) {
                slider.style.display = "flex";
                slider.style.flexWrap = "nowrap";
                slider.style.justifyContent = "flex-start";
                slider.style.width = "100%";
                // Ajusta o estilo dos cards para que caibam na tela
                cards.forEach((card) => {
                    card.style.flex = "0 0 auto";
                    if (!window.matchMedia("(max-width: 768px)").matches) {
                        card.style.marginRight = cardMargin + "px";
                    }
                });
                // Garante que temos a quantidade correta de dots de paginação
                if (paginationContainer) {
                    // Limpa os dots existentes
                    paginationContainer.innerHTML = "";
                    // Cria um dot para cada card
                    for (let i = 0; i < totalCards; i++) {
                        const dot = document.createElement("span");
                        dot.classList.add("pagination-dot");
                        if (i === 0)
                            dot.classList.add("active");
                        paginationContainer.appendChild(dot);
                        // Adiciona evento de clique para cada dot
                        dot.addEventListener("click", function () {
                            goToPosition(i);
                            updatePaginationDots();
                        });
                    }
                    // Atualiza a referência aos dots
                    paginationDots = document.querySelectorAll(".pagination-dot");
                }
            }
            // No mobile, mostra todos os cards disponíveis, mas ainda permite navegar entre eles
            const visibleCards = isMobile ? 1 : 3; // Número de cards visíveis simultaneamente
            const maxPosition = Math.max(0, totalCards - visibleCards); // Posição máxima
            // Configuração inicial dos botões de navegação
            updateNavButtons();
            // Função para navegar para uma posição específica
            function goToPosition(position) {
                // Limita a posição entre 0 e maxPosition
                position = Math.max(0, Math.min(position, maxPosition));
                currentPosition = position;
                const translateX = -currentPosition * cardStep;
                // Adiciona uma transição suave
                slider.style.transition = "transform 0.3s ease-in-out";
                slider.style.transform = `translateX(${translateX}px)`;
                // Atualiza o estado dos botões de navegação
                updateNavButtons();
                // Atualiza os dots de paginação
                updatePaginationDots();
            }
            // Atualiza a aparência dos botões de navegação com transição suave
            function updateNavButtons() {
                // Primeiro, remove a classe visible de ambos os botões
                prevButton.classList.remove("visible");
                nextButton.classList.remove("visible");
                // Aplica as classes com um pequeno delay para criar efeito de transição
                setTimeout(() => {
                    if (currentPosition === 0) {
                        // Na primeira posição, mostra apenas o botão de avançar
                        nextButton.classList.add("visible");
                    }
                    else if (currentPosition >= maxPosition) {
                        // Na última posição, mostra apenas o botão de voltar
                        prevButton.classList.add("visible");
                    }
                    else {
                        // Nas posições intermediárias, mostra ambos os botões
                        prevButton.classList.add("visible");
                        nextButton.classList.add("visible");
                    }
                }, 50);
            }
            // Evento: Clique no botão "anterior"
            prevButton.addEventListener("click", function () {
                goToPosition(currentPosition - 1); // Retrocede um card
            });
            // Evento: Clique no botão "próximo"
            nextButton.addEventListener("click", function () {
                goToPosition(currentPosition + 1); // Avança um card
            });
            // Adiciona suporte para gestos de swipe em todos os dispositivos
            let touchStartX = 0;
            let touchEndX = 0;
            function handleSwipe() {
                const swipeThreshold = 30; // Reduzindo o limite para facilitar a detecção de swipe
                const swipeDistance = touchEndX - touchStartX;
                if (swipeDistance > swipeThreshold) {
                    // Swipe para a direita (card anterior)
                    goToPosition(currentPosition - 1);
                }
                else if (swipeDistance < -swipeThreshold) {
                    // Swipe para a esquerda (próximo card)
                    goToPosition(currentPosition + 1);
                }
            }
            // Adiciona eventos de touch para swipe
            slider.addEventListener("touchstart", (e) => {
                touchStartX = e.changedTouches[0].screenX;
            }, { passive: true });
            slider.addEventListener("touchend", (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            }, { passive: true });
            // Adiciona eventos de mouse para simular swipe em desktop
            let isMouseDown = false;
            let mouseStartX = 0;
            let mouseEndX = 0;
            slider.addEventListener("mousedown", (e) => {
                isMouseDown = true;
                mouseStartX = e.clientX;
            });
            slider.addEventListener("mousemove", (e) => {
                if (!isMouseDown)
                    return;
                mouseEndX = e.clientX;
            });
            slider.addEventListener("mouseup", () => {
                if (!isMouseDown)
                    return;
                const swipeThreshold = 50;
                const swipeDistance = mouseEndX - mouseStartX;
                if (swipeDistance > swipeThreshold) {
                    // Swipe para a direita (card anterior)
                    goToPosition(currentPosition - 1);
                }
                else if (swipeDistance < -swipeThreshold) {
                    // Swipe para a esquerda (próximo card)
                    goToPosition(currentPosition + 1);
                }
                isMouseDown = false;
            });
            slider.addEventListener("mouseleave", () => {
                isMouseDown = false;
            });
            // Adiciona responsividade ao slider
            window.addEventListener("resize", function () {
                // Verifica se está em modo mobile após redimensionamento
                const newIsMobile = window.innerWidth <= 768;
                // Recalcula as dimensões dos cards
                const newCardWidth = cards[0].offsetWidth;
                const newCardStep = newCardWidth + cardMargin;
                // Atualiza o número de cards visíveis com base no novo tamanho de tela
                const newVisibleCards = newIsMobile ? totalCards : 3;
                const newMaxPosition = Math.max(0, totalCards - newVisibleCards);
                // Ajusta a posição atual se necessário
                currentPosition = Math.min(currentPosition, newMaxPosition);
                // Atualiza a posição do slider
                const translateX = -currentPosition * newCardStep;
                slider.style.transform = `translateX(${translateX}px)`;
                // Atualiza os botões de navegação
                updateNavButtons();
                // Atualiza os dots de paginação
                if (newIsMobile) {
                    updatePaginationDots();
                }
            });
            // Adiciona eventos para os dots de paginação (apenas para dots que não foram criados dinamicamente)
            if (!isMobile && paginationDots.length) {
                paginationDots.forEach((dot, index) => {
                    dot.addEventListener("click", function () {
                        // Navega para a posição correspondente ao dot
                        goToPosition(index);
                        updatePaginationDots();
                    });
                });
            }
            // Inicializa os dots de paginação
            updatePaginationDots();
            // Atualiza os dots de paginação
            function updatePaginationDots() {
                if (paginationDots.length) {
                    paginationDots.forEach((dot, index) => {
                        if (index === currentPosition) {
                            dot.classList.add("active");
                        }
                        else {
                            dot.classList.remove("active");
                        }
                    });
                }
            }
        }
    });
    /**
     * Classe Scratchcard
     * Componente que revela conteúdo ao clicar com animação de PNGs
     */
    class Scratchcard {
        element;
        scratchContent;
        resultContent;
        overlay;
        frames;
        currentFrameIndex;
        animationInterval;
        constructor(element) {
            this.element = element;
            this.scratchContent = element.querySelector(".scratch-content");
            this.resultContent = element.querySelector(".scratchcard-result");
            this.overlay = element.querySelector(".scratch-overlay");
            this.frames = element.querySelectorAll(".scratch-frame");
            this.currentFrameIndex = 0;
            this.animationInterval = null;
            this.init();
        }
        init() {
            // Pré-carrega as imagens
            this.preloadImages();
            // Adiciona o evento de clique
            this.element.addEventListener("click", () => this.startScratch());
            this.element.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    this.startScratch();
                }
            });
        }
        preloadImages() {
            // Garante que as imagens sejam carregadas antes da animação
            this.frames.forEach((frame) => {
                const img = new Image();
                img.src = frame.src;
            });
        }
        startScratch() {
            // Já está em animação
            if (this.element.classList.contains("scratching")) {
                return;
            }
            // Esconde o conteúdo inicial
            this.scratchContent.classList.add("hidden");
            // Inicia a animação de raspagem
            this.element.classList.add("scratching");
            // Anima os frames em sequência
            this.animateFrames();
        }
        animateFrames() {
            // Limpa qualquer animação anterior
            if (this.animationInterval) {
                clearInterval(this.animationInterval);
            }
            // Remove a classe ativa de todos os frames
            this.frames.forEach((frame) => frame.classList.remove("active"));
            // Inicia com o segundo frame (State_02.png)
            this.currentFrameIndex = 1; // Começa do índice 1 (State_02.png)
            this.frames[this.currentFrameIndex].classList.add("active");
            // Anima os frames em sequência
            this.animationInterval = setInterval(() => {
                // Remove a classe ativa do frame atual
                this.frames[this.currentFrameIndex].classList.remove("active");
                // Avança para o próximo frame
                this.currentFrameIndex++;
                // Se chegou ao final (após State_06.png), revela o prêmio
                if (this.currentFrameIndex >= this.frames.length) {
                    clearInterval(this.animationInterval);
                    this.revealPrize();
                    return;
                }
                // Ativa o próximo frame
                this.frames[this.currentFrameIndex].classList.add("active");
            }, 150); // Troca a cada 700ms para manter a animação fluida
        }
        revealPrize() {
            // Revela o conteúdo do prêmio
            this.element.classList.add("revealed");
            this.resultContent.setAttribute("tabindex", "3");
            this.resultContent.focus();
            // Remove a classe de raspagem
            this.element.classList.remove("scratching");
        }
    }
}
